import style from './categorySelector.module.css';

import React from 'react'

interface Props {
  title: string;
  id: number;
  selected: boolean;
  Icon: React.ComponentType<any>;
  callbackFunction: (id: number) => void;
}

function CategorySelector({ title, id, selected, Icon, callbackFunction }: Props) {
  const selectedClass = selected ? style.selected : "";
  return <button onClick={() => callbackFunction(id)} className={style.wrapper + " " + selectedClass}>
    <Icon stroke="white" strokeWidth={1.5} className={style.buttonIcon} />
    {title}
  </button>
}

export default CategorySelector;
